import { Label } from "@/components/ui/label";

/**
 * Always-visible per-size quantity row for a garment line.
 * Sizes are driven by the product's size list. The sum of size quantities
 * OVERRIDES the line quantity (matches the approved mockup).
 */
export function GarmentSizesRow({ garment, sizes = [], index, onUpdateFields, disabled = false }) {
  if (!sizes || sizes.length === 0) return null;

  const sizeBreakdown = garment.size_breakdown || {};
  const total = Object.values(sizeBreakdown).reduce((s, q) => s + (parseInt(q) || 0), 0);

  const handleChange = (size, raw) => {
    const qty = parseInt(raw) || 0;
    const next = { ...sizeBreakdown };
    if (qty > 0) next[size] = qty;
    else delete next[size];
    const sum = Object.values(next).reduce((s, q) => s + (parseInt(q) || 0), 0);
    // Sum of sizes overrides the single line quantity
    onUpdateFields({ size_breakdown: next, quantity: sum > 0 ? sum : garment.quantity });
  };

  return (
    <div className="col-span-2 sm:col-span-12 mt-1" data-testid={`garment-sizes-row-${index}`}>
      <Label className="text-xs text-muted-foreground mb-1.5 block">Garment Sizes</Label>
      <div className="flex flex-wrap items-end gap-2">
        {sizes.map((size) => (
          <div key={size} className="flex flex-col items-center">
            <span className="text-[11px] font-medium text-gray-500 mb-0.5">{size}</span>
            <input
              type="number"
              min="0"
              inputMode="numeric"
              value={sizeBreakdown[size] ?? ""}
              onChange={(e) => handleChange(size, e.target.value)}
              disabled={disabled}
              placeholder="0"
              data-testid={`garment-${index}-size-${size}`}
              className={`w-12 h-9 text-center text-sm font-mono border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400/40 transition-colors ${
                (parseInt(sizeBreakdown[size]) || 0) > 0
                  ? "bg-blue-50 border-blue-300 text-blue-700"
                  : "bg-white border-gray-200"
              }`}
            />
          </div>
        ))}
        {/* Total Qty */}
        <div className="flex flex-col items-start ml-auto">
          <span className="text-[11px] font-medium text-gray-500 mb-0.5">Total Qty</span>
          <div
            className="min-w-[90px] h-9 px-3 flex items-center justify-center rounded-md border border-gray-200 bg-gray-50 font-mono text-sm font-semibold text-gray-800"
            data-testid={`garment-${index}-total-qty`}
          >
            {total}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GarmentSizesRow;
